import beadcompassLogo from "../../assets/branding/beadcompass.svg";
import pyxisLogo from "../../assets/branding/pyxis.svg";
import classes from "./PartnerLogos.module.css";

type PartnerLogosProps = {
  className?: string;
  compact?: boolean;
  label?: string;
  separated?: boolean;
  shiftPyxis?: boolean;
  desktop?: boolean;
};

const PartnerLogos = ({
  className = "",
  compact = false,
  label,
  separated = false,
  shiftPyxis = false,
  desktop = false,
}: PartnerLogosProps) => {
  const containerClassName = [
    classes.partners,
    compact ? classes.compact : "",
    desktop ? classes.desktop : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClassName} aria-label="Powered by BeadCompass y Pyxis">
      {label && <span className={classes.label}>{label}</span>}
      <div className={classes.logos}>
        <img className={`${classes.logo} ${classes.beadcompass}`} src={beadcompassLogo} alt="BeadCompass" />
        {separated && <span className={classes.separator} aria-hidden="true">│</span>}
        <a href="https://pyxis.tech" target="_blank" rel="noreferrer" aria-label="Pyxis">
          <img className={`${classes.logo} ${classes.pyxis} ${shiftPyxis ? classes.shiftPyxis : ""}`} src={pyxisLogo} alt="Pyxis" />
        </a>
      </div>
    </div>
  );
};

export default PartnerLogos;
